import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const NavigationText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID, text } = props;

    return (
        <LabelText className={`${className} ${styles.navigationText}`} testId={testId}>
            {children || text}
        </LabelText>
    );
};

NavigationText.displayName = 'NavigationText';

export default NavigationText;
